import projects from "../data/projects";
import site from "../data/site";
import ProjectTable from "../components/ProjectTable";
import useMediaQuery from "../hooks/useMediaQuery";
import useDocumentTitle from "../hooks/useDocumentTitle";

/**
 * The home page: a short bio, then the project table.
 * The bio text lives in `src/data/site.js`.
 *
 * Devices with a real mouse open rows on hover; phones, tablets and other
 * touch screens open them as you scroll. This query is the only place that
 * is decided.
 */
const HOVER_QUERY = "(hover: hover) and (pointer: fine)";

export default function IndexPage() {
  useDocumentTitle();
  const canHover = useMediaQuery(HOVER_QUERY);

  return (
    <ProjectTable
      // `key` resets the table cleanly if the mode switches
      key={canHover ? "hover" : "scroll"}
      projects={projects}
      mode={canHover ? "hover" : "scroll"}
    >
      <div className="index-bio">
        {site.bio.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </div>
    </ProjectTable>
  );
}
